import { Text } from '@cretesuite/design-system'
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { useState } from 'react'
import { TermsFormat } from '../gql/graphql'
import { Markdown } from './Markdown'

export type TermsContent = {
  title?: string | null
  body?: string | null
  format?: TermsFormat | null
}

type TermsAcknowledgmentProps = {
  /** `order.terms.content`; when absent the text renders without a link. */
  content?: TermsContent | null
  /** Style for the acknowledgment text (each signature modal differs). */
  textStyle?: React.ComponentProps<typeof Text>['style']
}

/**
 * "By clicking submit…" acknowledgment for the signature modals — the terms
 * title opens the full Terms & Conditions in a modal (v1 parity).
 */
export const TermsAcknowledgment = ({
  content,
  textStyle,
}: TermsAcknowledgmentProps) => {
  const { _ } = useLingui()
  const [showTerms, setShowTerms] = useState(false)
  const title = content?.title || _(msg`Terms & Conditions`)

  return (
    <>
      <Text variant='body' style={textStyle}>
        {_(
          msg`By clicking submit, you acknowledge you have read and agree to the`,
        )}{' '}
        {content ? (
          <button
            type='button'
            className='terms-link'
            onClick={() => setShowTerms(true)}
          >
            {title}
          </button>
        ) : (
          title
        )}
      </Text>

      {content && (
        <IonModal isOpen={showTerms} onDidDismiss={() => setShowTerms(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>{title}</IonTitle>
              <IonButtons slot='end'>
                <IonButton onClick={() => setShowTerms(false)}>
                  {_(msg`Close`)}
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen className='ion-padding'>
            {content.format === TermsFormat.Markdown ? (
              <Markdown>{content.body ?? ''}</Markdown>
            ) : (
              content.body
            )}
            <IonButton
              expand='block'
              className='ion-margin-top'
              onClick={() => setShowTerms(false)}
            >
              {_(msg`Close`)}
            </IonButton>
          </IonContent>
        </IonModal>
      )}
    </>
  )
}
